import { SdkMessageTypes } from '../constants';
import { HostedWebContentSdkService } from '../hosted-web-content-sdk';
import { IDialogService, DialogSize, DialogInfo, DialogContentType, Dialog, ITelemetryService } from '../interfaces';
import { BaseMessageHandler } from './base-message-handler';
/**
 * Responsible for dialogs module related message requests.
 */
export class DialogsMessageHandler extends BaseMessageHandler {
  constructor(
    appSdkHost: HostedWebContentSdkService,
    private dialogService?: IDialogService,
    telemetryService?: ITelemetryService
  ) {
    super(appSdkHost, telemetryService);
  }
  public initHandlers(): void {
    this.registerHandler(SdkMessageTypes.dialogs.open, async (_, dialogInfo: DialogInfo) => {
      if (dialogInfo.card && dialogInfo.url) {
        return ['Values for both card and url were specified. One or the other, but not both, are allowed.'];
      }

      let dialog: Dialog;
      if (dialogInfo.url) {
        dialog = { ...dialogInfo, url: dialogInfo.url, type: DialogContentType.Url };
      } else if (dialogInfo.card) {
        dialog = { ...dialogInfo, card: dialogInfo.card, type: DialogContentType.Card };
      } else {
        return ['You must specify a value for either card or url.'];
      }

      try {
        const result = await this.dialogService!.open(dialog);
        return [null, result];
      } catch (_) {
        return ['User cancelled/closed the task module.'];
      }
    });
    this.registerHandler(SdkMessageTypes.dialogs.resize, (_, dialogSize: DialogSize) =>
      this.dialogService!.resize(dialogSize)
    );
    this.registerHandler(SdkMessageTypes.dialogs.submit, (_, result?: string | Object, appIds?: string[]) =>
      this.dialogService!.submit(result, appIds)
    );
  }

  protected validateDependencies() {
    if (!this.dialogService) {
      throw 'No dialogService provided';
    }
  }
}
